import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import { useAppContext } from "../../AppContext";
import orderRoute from "../../services/orderRoute";
import arrowLeft from "../../assets/arrow-left.svg";

const BulkUpdateModal = ({ show, onHide, action, selectedLgaIds, selectedLgaNames, onSuccess }) => {
  const { showToast } = useAppContext();
  const { bulkUpdateDeliveryDays } = orderRoute();
  const [loading, setLoading] = useState(false);
  const [selectedDays, setSelectedDays] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [step, setStep] = useState(1);

  const daysOfWeek = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

  const handleDayToggle = (day) => {
    setSelectedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const handleApply = () => {
    if (selectedDays.length === 0) {
      showToast({ toastText: "Please select at least one day", isSuccess: false });
      return;
    }
    setStep(2);
  };

  const handleConfirm = () => {
    const body = {
      lgaIds: selectedLgaIds,
      days: selectedDays,
      action: action,
      startDate: startDate || undefined,
      endDate: endDate || undefined,
    };

    bulkUpdateDeliveryDays(body, setLoading, showToast, () => {
      onSuccess();
      handleClose();
    });
  };

  const handleClose = () => {
    setSelectedDays([]);
    setStartDate("");
    setEndDate("");
    setStep(1);
    onHide();
  };

  const formatDays = (days) => {
    return days.map((d) => d.charAt(0).toUpperCase() + d.slice(1)).join(", ");
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title
          style={{
            color: "#344054",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            gap: "20px",
          }}
        >
          {step === 2 && (
            <img
              src={arrowLeft}
              alt="back"
              onClick={() => setStep(1)}
              style={{ cursor: "pointer" }}
            />
          )}
          {action === "activate" ? "Activate" : "Deactivate"} Delivery Days
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-4">
        {step === 1 ? (
          <>
            <div className="mb-4">
              <h6 style={{ fontWeight: "600", color: "#344054" }}>Locations:</h6>
              <p style={{ color: "#667085", fontSize: "14px" }}>
                {selectedLgaIds.length === 0
                  ? "Applying to ALL locations"
                  : `Selected (${selectedLgaIds.length}): ${
                      selectedLgaNames.length > 20
                        ? selectedLgaNames.slice(0, 20).join(", ") + "..."
                        : selectedLgaNames.join(", ")
                    }`}
              </p>
            </div>

            <div className="mb-4">
              <h6 style={{ fontWeight: "600", color: "#344054" }}>Select Delivery Days:</h6>
              <Row className="mt-2">
                {daysOfWeek.map((day) => (
                  <Col key={day} xs={6} md={3} className="mb-2">
                    <Form.Check
                      type="checkbox"
                      id={`bulk-day-${day}`}
                      label={day.charAt(0).toUpperCase() + day.slice(1)}
                      checked={selectedDays.includes(day)}
                      onChange={() => handleDayToggle(day)}
                      style={{ cursor: "pointer" }}
                    />
                  </Col>
                ))}
              </Row>
            </div>

            <Row className="mb-4">
              <Col md={6}>
                <Form.Group controlId="startDate">
                  <Form.Label style={{ fontWeight: "600", color: "#344054" }}>
                    Start Date (Optional)
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="endDate">
                  <Form.Label style={{ fontWeight: "600", color: "#344054" }}>
                    End Date (Optional)
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        ) : (
          <div className="py-3">
            <div className="text-center">
              <h5 style={{ color: "#344054", marginBottom: "20px" }}>
                Are you sure you want to {action} ({formatDays(selectedDays)}) for{" "}
                {selectedLgaIds.length === 0 ? "ALL locations" : "these locations"}?
              </h5>
              {startDate && endDate && (
                <p style={{ color: "#475467", fontSize: "18px", fontWeight: "600" }}>
                  From {startDate} to {endDate}
                </p>
              )}
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 px-4 pb-4">
        <Button
          variant="outline-secondary"
          onClick={step === 1 ? handleClose : () => setStep(1)}
          className="px-4"
        >
          {step === 1 ? "Cancel" : "Back"}
        </Button>
        {step === 1 ? (
          <Button
            variant={action === "activate" ? "primary" : "danger"}
            onClick={handleApply}
            className="px-4"
          >
            {action === "activate" ? "Activate" : "Deactivate"}
          </Button>
        ) : (
          <Button
            variant={action === "activate" ? "success" : "danger"}
            onClick={handleConfirm}
            disabled={loading}
            className="px-4"
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              `Yes, ${action.charAt(0).toUpperCase() + action.slice(1)}`
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default BulkUpdateModal;
